import React, { useState } from "react";
import { useIntl } from "react-intl";
import Typography from "antd/lib/typography/Typography";
import Form from "antd/lib/form";
import Input from "antd/lib/input";
import Checkbox from "antd/lib/checkbox";
import Button from "antd/lib/button";
import InfoMessage from "@codex/components/Messages";
import { store } from "@codex/store/index";
import { hideMessage } from "@codex/app-ducks/actions";
var LoginForm = function (props) {
    var classes = props.classes, form = props.form, messageInfo = props.messageInfo, errorInfo = props.errorInfo;
    var formatMessage = useIntl().formatMessage;
    var _a = useState(false), isRegister = _a[0], setRegister = _a[1];
    var _b = useState(false), showLoginInputStatus = _b[0], setLoginInputStatusVisibility = _b[1];
    var _c = useState(false), showPhoneInputStatus = _c[0], setPhoneInputStatusVisibility = _c[1];
    var getFieldDecorator = form.getFieldDecorator;
    return (React.createElement("div", { className: classes.root },
        React.createElement(Typography, { className: classes.title }, formatMessage({ id: "loginForm.title" })),
        React.createElement(Typography, { className: classes.subTitle }, isRegister
            ? formatMessage({ id: "loginForm.NotCodexUsers" })
            : (React.createElement("div", null,
                React.createElement("span", null, formatMessage({ id: "brand" })),
                " ",
                formatMessage({ id: "loginForm.codexUsers" })))),
        React.createElement(Form, { className: classes.form, onSubmit: function (e) {
                e.preventDefault();
                props.form.validateFields(function (err, values) {
                    if (!err) {
                        if (isRegister) {
                            props.registerRequest({
                                email: values.email,
                                phone: values.phone
                            });
                            return;
                        }
                        props.loginRequest({
                            email: values.email,
                            phone: values.phone
                        });
                    }
                });
            } },
            React.createElement(Form.Item, { hasFeedback: showLoginInputStatus, label: formatMessage({ id: "loginForm.email" }) }, getFieldDecorator("email", {
                rules: [
                    { required: true, message: formatMessage({ id: "loginForm.email.error.massage" }) },
                    { type: "email", message: formatMessage({ id: "loginForm.email.error.massage" }) },
                ],
                normalize: function (value) { return value ? value.trim() : value; },
                validateTrigger: 'onBlur',
            })(React.createElement(Input, { className: classes.largeInput, onInput: function () {
                    form.resetFields(['email']);
                }, onBlur: function () { return setLoginInputStatusVisibility(true); }, onFocus: function () { return setLoginInputStatusVisibility(false); }, size: "large", placeholder: formatMessage({ id: "loginForm.email.placeHolder" }) }))),
            React.createElement(Form.Item, { hasFeedback: showPhoneInputStatus, label: formatMessage({ id: "loginForm.phone" }) }, getFieldDecorator("phone", {
                rules: [
                    { required: true, message: formatMessage({ id: "loginForm.phone.error.massage" }) },
                    {
                        pattern: /^(\+\d{1,3}[- ]?)?\d{10}$/,
                        message: formatMessage({ id: "loginForm.phone.error.massage" }),
                    },
                ],
                normalize: function (value) { return value ? value.slice(0, 10) : value; },
                validateTrigger: 'onBlur'
            })(React.createElement(Input, { className: classes.largeInput, size: "large", onInput: function () {
                    form.resetFields(['phone']);
                }, onBlur: function () { return setPhoneInputStatusVisibility(true); }, onFocus: function () { return setPhoneInputStatusVisibility(false); }, placeholder: formatMessage({ id: "loginForm.phone.placeHolder" }) }))),
            React.createElement(Form.Item, { className: classes.chckBx, hasFeedback: true },
                getFieldDecorator("agree", {
                    valuePropName: "checked",
                    initialValue: false,
                    rules: [
                        {
                            required: true,
                            transform: function (value) { return (value || undefined); },
                            type: 'boolean',
                            message: formatMessage({ id: "loginForm.agree.error.massage" })
                        }
                    ]
                })(React.createElement(Checkbox, { className: classes.errorCheckbox, onChange: function () { return store.dispatch(hideMessage()); } },
                    formatMessage({ id: "loginForm.beforePrivacy" }),
                    React.createElement("a", { href: "https://www.codex.co.il/terms-and-conditions/", target: "_blank", className: classes.blueAgree }, formatMessage({ id: "loginForm.privacy" })),
                    formatMessage({ id: "loginForm.afterPrivacy" }),
                    React.createElement("a", { href: "https://www.codex.co.il/privacy/", target: "_blank", className: classes.blueAgree }, formatMessage({ id: "loginForm.terms" })),
                    formatMessage({ id: "loginForm.afterTerms" }))),
                React.createElement(InfoMessage, { isMessageShown: messageInfo.isMessageShown, messageCode: errorInfo.code, messageText: errorInfo.data, messageType: errorInfo.type })),
            React.createElement(Button, { htmlType: "submit", className: classes.btn + " " + (messageInfo.isMessageShown ? 'with-error' : '') }, formatMessage({ id: "loginForm.sendVerification" })),
            React.createElement("a", { onClick: function () {
                    setRegister(!isRegister);
                    props.form.resetFields();
                    store.dispatch(hideMessage());
                }, className: classes.rgstrLink }, isRegister
                ? formatMessage({ id: "loginForm.login" })
                : formatMessage({ id: "loginForm.signUp" })))));
};
export default LoginForm;



//////////////////
// WEBPACK FOOTER
// ./src/components/LoginForm/LoginForm.tsx
// module id = 738
// module chunks = 0